import React, { FC, useEffect } from "react";
import { useAppSelector } from "../../store/hooks";
import { selectDirection } from "../../store/selectors/appSelectors";
import { isMobile } from "../../utils/helpers/mediaQueries";
import { useNonDesktopViewport } from "../../utils/hooks/useNonDesktopViewport";
import LangSelect from "../LangSelect/LangSelect";
import WhatsappHelp from "../WhatsappHelp/WhatsappHelp";
import useGlobalNotification from "../../utils/hooks/useGlobalNotification";
import GlobalNotificationCampaignBanner from "../GlobalNotificationCampaignBanner";

import styles from "./sidebar.module.scss";

/**
 * Sidebar wrapper
 * */

const Sidebar: FC<{ children: any }> = ({ children }) => {
  const isNonDesktop = useNonDesktopViewport();
  const dir = useAppSelector(selectDirection);
  const { activeCampaignNotification } = useGlobalNotification();

  // show sidebar for 0.3 sec if it is small desktop for the first time
  useEffect(() => {
    const sidebarElement = document.getElementById("sidebar-wrapper");

    if (sidebarElement) {
      const isSidebarShown = localStorage.getItem("isSidebarShown");
      if (!isSidebarShown) {
        sidebarElement.classList.add(styles.hideWithDelay);

        setTimeout(() => {
          sidebarElement.classList.remove(styles.hideWithDelay);
        }, 600);
        localStorage.setItem("isSidebarShown", "true");
      }
    }
  }, []);

  return (
    <div className={styles.wrapper} id="sidebar-wrapper" dir={dir}>
      {children}
      {activeCampaignNotification && (
        <GlobalNotificationCampaignBanner notification={activeCampaignNotification} />
      )}
      {/* {!isNonDesktop && <WhatsappHelp />} */}
      {isMobile() && (
        <div className={styles.langSelectWrapper}>
          <LangSelect />
        </div>
      )}
    </div>
  );
};

export default Sidebar;
